module.exports = new __parcel__URL__("nvap_logo_full_900w.42183c72.png").toString();